import { render } from "./TotalCourses.vue?vue&type=template&id=c9f54b22&ts=true"
import script from "./TotalCourses.vue?vue&type=script&lang=ts"
export * from "./TotalCourses.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__